export default __webpack_public_path__ + "static/media/example1.eb2853fa.jpg";